<template>
  <div class="Div">
    <div class="backimg">
      <img
        class="img"
        :src="detail.info.details_background_img"
        alt=""
      >
      <div class="Title">
         {{detail.info.overview_title_cn}}

      </div>
    </div>
    <section class="section1">
      <div class="stitle">
        <p class="p">{{detail.info.details_title_cn}}</p>
        <p class="p">{{detail.info.details_title_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="introduction" v-html="detail.info.content_cn">
        <!-- 以人为本的教学策略及有效的学校管理，尊重学生生活， 激发学习潜质，关爱终身成就。 -->
      </div>
      <!-- <div>
        <img
          v-for="i of 3"
          :key="i"
          class="img1"
          src="../../../static/image/home3-5.png"
          alt=""
        >
      </div>
      <div class="scontent">
        <div class="div">
          <div class="pioneer">
            <div class="text">
              <div class="title">
                万丈高楼平地起
              </div>
              <div class="summary">
                我们始终秉承教育的本质在于激发学生的发展潜能，努力为学生的个性发展、全面发展、终身发展奠定坚实基础的办学理念，
                坚持以人为本的教育思想，追求学生、教师、学校 “三位一体”的和谐发展，以培养品行优良、身心健康、学业优秀，
                既具扎实文化知识基础，又具突出外语特长，融汇中西，具有创新能力和国际视野，能适应二十一世纪挑战的优秀人才为目标。
              </div>
            </div>
          </div>
          <img
            class="img"
            src="../../../static/image/home3-4.png"
            alt=""
            srcset=""
          >
        </div>
        <div class="div">
          <img
            class="img"
            src="../../../static/image/home3-4.png"
            alt=""
            srcset=""
          >
          <div class="pioneer pioneer1">
            <div class="text">
              <div class="title">
                为未来加油！
              </div>
              <div class="summary">
                成实外教育以人为本的教学策略及有效的学校管理，尊重学生生活，激发学习潜质，关爱终身成就。
                我们亦注重培养及促进学生全面发展，使他们面对未来挑战做好准备。
              </div>
            </div>
          </div>
        </div>

      </div> -->
    </section>
  </div>
</template>
<script>
import { overviewDetails } from "../../api/Overview";
export default {
 data() {
    return {
      detail: { info:{}, banner: {} }
    };
  },
  created() {
    var id=this.$route.query.uid
    overviewDetails({overview_id:id}).then(res => {
      // console.log(res.data);
      this.detail = res.data;
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  padding: 0.1px 0;
  //   background: #f5f5f5;
  .backimg {
    position: relative;
    width: 100%;
    height: px2Rem(400px);
    &::after {
      display: block;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      //   z-index: 1;
    }
    .img {
      //   position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.Title {
  position: absolute;
  width: 100%;
  top: px2Rem(129px);
  font-size: px2Rem(80px);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  z-index: 1;
  text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  p {
    margin-top: px2Rem(20px);
    font-size: px2Rem(40px);
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  }
}
.section1 {
  width: px2Rem(1300px);
  margin: px2Rem(40px) auto px2Rem(77px);
  .introduction {
    // width: px2Rem(628px);
    margin: px2Rem(25px) auto px2Rem(60px);
    font-size: px2Rem(28px);
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    // text-align: center;
  }
  .img1 {
    display: inline-block;
    width: px2Rem(410px);
    height: px2Rem(280px);
    margin-right: px2Rem(35px);
    margin-bottom: px2Rem(60px);
    &:nth-of-type(3n) {
      margin-right: 0;
    }
  }
  .scontent {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    .div {
      height: px2Rem(444px);
      font-size: 0;
    }
    .img {
      display: inline-block;
      width: px2Rem(650px);
      height: 100%;
      vertical-align: top;
    }
    .pioneer {
      position: relative;
      display: inline-block;
      width: px2Rem(620px);
      height: 100%;
      //   padding: 0 px2Rem(30px);
      margin-right: px2Rem(30px);
      background: rgba(255, 255, 255, 1);
      .text {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
      }
      .title {
        margin: px2Rem(0px) 0 px2Rem(40px);
        font-size: px2Rem(34px);
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      .summary {
        line-height: px2Rem(30px);
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
    .pioneer1 {
      margin-right: px2Rem(0px);
      margin-left: px2Rem(30px);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/OverviewAndWelcome/OverviewDetailHigh.vue